import type { ITelemetryItem } from "@microsoft/applicationinsights-web";
import useUserStore from "~/stores/user";
import { insights } from "../insights";

const addUserToTelemetry = (envelop: ITelemetryItem) => {
	let user = {
		username: "Anonymous",
		userId: undefined as unknown as string,
		communicationId: undefined as unknown as string,
	};

	const selfUser = useUserStore.getState().getUser();

	if (selfUser) {
		user = {
			username: selfUser.username ?? "Anonymous",
			userId: selfUser.id!,
			communicationId: selfUser.communicationId!,
		};
	}

	if (envelop.data) {
		envelop.data.user = user;
	}
};

insights.addTelemetryInitializer(addUserToTelemetry);
